import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import {  AuthProvider } from "./context/AuthContext";
import React, {  useEffect, useState, Suspense, lazy } from "react";

import Navbar from "./components/Navbar.jsx";
import BackToTop from "./components/BackToTop.jsx";
import Footer from "./components/Footer.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";

// Lazy Load Pages for Better Performance
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const TermsAndCondition = lazy(() => import("./pages/TermsAndCondition.jsx"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy.jsx"));
const Cookis = lazy(() => import("./pages/Cookies.jsx"));
const Faqs = lazy(() => import("./pages/Faqs.jsx"));
const Spices = lazy(() => import("./pages/Spices.jsx"));
const Sugar = lazy(() => import("./pages/Sugar.jsx"));
const VajjiramTechnology = lazy(() => import("./pages/VajjiramTechnology.jsx"));
const OurApproach = lazy(() => import("./pages/OurApproach.jsx"));
const BlogPage = lazy(() => import("./pages/Blog.jsx"));
const Staples = lazy(() => import("./pages/Staples.jsx"));
const ProductDetails = lazy(() => import("./components/ProductDetails.jsx"));
const BusinessPage = lazy(() => import("./pages/BusinessPage.jsx"));
const HelpMain = lazy(() => import("./pages/HelpAndSupport.jsx"));
const Community = lazy(() => import("./pages/Community.jsx"));
const DalNDPulses = lazy(() => import("./pages/DalNDPulses.jsx"));
const DryFruites = lazy(() => import("./pages/DryFruites.jsx"));
const Seeds = lazy(() => import("./pages/Seeds.jsx"));

const AppContent = () => {
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith("/dashboard");

  // Loading state for route changes
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500); // Simulate a loading delay
    return () => clearTimeout(timer);
  }, [location]);

  const LoadingFallback = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500"></div>
    </div>
  );

  return (
    <>
      {!isDashboardRoute && <Navbar />}
      <ScrollToTop />

      {loading && <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
    </div>} {/* Show loading screen while switching routes */}
      
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/our-products/staples" element={<Staples />} />
          <Route exact path="/our-products/dry-fruits" element={<DryFruites />} />
          <Route exact path="/our-products/dals-pulses" element={<DalNDPulses />} />
          <Route exact path="/our-products/whole-spices" element={<Spices />} />
          <Route exact path="/our-products/sugar" element={<Sugar />} />
          <Route exact path="/our-products/seeds" element={<Seeds />} />
          <Route exact path="/blog" element={<BlogPage />} />
          <Route exact path="/technology/vajjiram-kart" element={<VajjiramTechnology />} />
          <Route exact path="/our-approach" element={<OurApproach />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/terms-conditions" element={<TermsAndCondition />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/our-commitment" element={<Community />} />
          <Route exact path="/product" element={<ProductDetails />} />
          <Route exact path="/business" element={<BusinessPage />} />
          <Route exact path="/cookies" element={<Cookis />} />
          <Route exact path="/faqs" element={<Faqs />} />
          <Route exact path="/help" element={<HelpMain />} />

          {/* Backend-related routes */}
          
        </Routes>
      </Suspense>

      {!isDashboardRoute && (
        <>
          <Footer />
          <BackToTop />
        </>
      )}
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

const RootApp = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

export default RootApp;
